module.exports = __webpack_public_path__ + "img/personnage_choix_1.813fb662.png";